import React, { useState } from 'react';
import {
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButton,
  IonInput,
  IonButtons,
  IonPage,
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonDatetime,
  IonDatetimeButton,
  IonAlert,
  IonToast,
  IonLoading
} from '@ionic/react';

import { Api } from '../services/api';
import { checkmarkCircleOutline, warning } from 'ionicons/icons';
import { log } from 'console';

interface ModalContentProps {
    api: Api;
    onDismiss: () => void;
  }
const AddLeaveComponent: React.FC<ModalContentProps>= ({api, onDismiss}) => {
  const [selectedLeaveType, setSelectedLeaveType] = useState<any>(null);
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [leaveUnits, setLeaveUnits] = useState<string | any>();
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [noErrors, setNoErrors] = useState(false);
  const [startDate, setStartDate] = useState<string | any>(getCurrentDate());
  const [endDate, setEndDate] = useState<string | any>(getCurrentDate());
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);

  function getCurrentDate() {
    const now = new Date();
    return `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}T${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
  }

  const handleSelectionChangeLeaveType = (event: CustomEvent) => {
    const selectedIndex = event.detail.value;
    console.log(selectedIndex);
    
    setSelectedLeaveType(selectedIndex);
  };


  const submit = async () => {

    if(!selectedLeaveType){
      setMessage('Please select Leave Type.');
      setNoErrors(true);
      setIsOpen(true);
      return;
    }
    setLoading(true);
    const data : any = {
      leave_type : selectedLeaveType || null,
      start_date : startDate || null,
      end_date : endDate || null,
      leaveUnits : leaveUnits || null,
    }
    console.log('data', data);

    
    
    const response = await api.rosters.submitLeave(data);
    if(!response){
      setMessage('Error Submiting Leave Request.');
      setNoErrors(false);
      setIsOpen(true);
    }else{
      setMessage('Leave Request submitted successfully.');
      setNoErrors(true);
      setIsOpen(true);
      onDismiss();
    }
    
    setLoading(false);
    
  }
  

  

  return (
    <IonPage >
      <IonHeader>
        <IonToolbar>
         <IonButtons slot="start">
            <IonButton color="medium" onClick={() => onDismiss()}>
              Cancel
            </IonButton>
          </IonButtons>
          <IonTitle>Add Leave</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className='p-1'>
            <IonItem>
                <IonLabel>Leave Types</IonLabel>
                <IonSelect
                  value={selectedLeaveType ? selectedLeaveType : ''}
                  placeholder="Select Leave Type"
                  onIonChange={handleSelectionChangeLeaveType}
                >
                  {
                    Object.keys(api.rosters?.resources?.leaveTypes).map((key, index) => {
                      return (
                        <IonSelectOption key={index} value={key}>{api.rosters?.resources?.leaveTypes[key]}</IonSelectOption>
                      )
                    }
                    )
                  }
                </IonSelect>
                 
            </IonItem>
            <IonItem>
                <IonLabel>Start Date</IonLabel>
                <IonDatetimeButton datetime="startdate"/>
                <IonModal keepContentsMounted={true}>
                  <IonDatetime 
                    id="startdate"
                    presentation="date"
                    min={ `${new Date().getFullYear()}` } 
                    max={ `${new Date().getFullYear() + 1}`  } 
                    onIonChange={(e) => setStartDate(e.detail.value!)}
                    showDefaultButtons={true} />
                </IonModal>
            </IonItem>
            <IonItem>
                <IonLabel>End Date</IonLabel>
                <IonDatetimeButton datetime="enddate" />
                <IonModal keepContentsMounted={true}>
                  <IonDatetime 
                    id="enddate" 
                    presentation="date"
                    min={ `${new Date().getFullYear()}` } 
                    max={ `${new Date().getFullYear() + 1}`  } 
                    onIonChange={(e) => setEndDate(e.detail.value!)}
                    showDefaultButtons={true} />
                </IonModal>
            </IonItem>
            <IonItem className="rounded mt-2 mb-2">
              <IonInput label="Leave Units" labelPlacement="floating" clearInput={true}  placeholder="Type Leave Units No. here" value={leaveUnits} onIonInput={(e) => setLeaveUnits(e.target.value!)}></IonInput>
            </IonItem>
            <IonButton className='mt-3' expand="full" shape='round' type="submit" color="light" onClick={()=>setIsAlertOpen(true)}>
                Submit
            </IonButton>
        </div>
        
        
        <IonAlert
          header="Confirmation"
          subHeader="Are you sure you want to submit the timesheet?"
          trigger="submit-alert"
          isOpen={isAlertOpen}
          buttons={[
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
              },
            },
            {
              text: 'Confirm',
              role: 'confirm',
              handler: (e) => {
                submit();
              },
            },
          ]}
          onDidDismiss={() => setIsAlertOpen(false)}
        ></IonAlert>
        <IonToast
          isOpen={isOpen}
          message={message}
          onDidDismiss={() => setIsOpen(false)}
          duration={3000}
          position= 'top'
          icon={(noErrors) ? checkmarkCircleOutline : warning}
          color="danger"
        ></IonToast>
        <IonLoading
          isOpen={loading}
          onDidDismiss={() => setLoading(false)}
          message={'Please wait...'}
        />
      </IonContent>
    </IonPage>
  );
};

export default AddLeaveComponent;